 let selectedProductIdd = null;
let which_is=0;
 let selectedCategoryId= null;
export const getSelectedCategoryIdd = () => selectedCategoryId;
export const setSelectedCategoryIdd= (id) => {
  selectedCategoryId = id;
};



export const getSelectedProductIdd = () => selectedProductIdd;
export const setSelectedProductIdd = (id) => {
  selectedProductIdd = id;
};

export const getWhich_is = () => which_is;
export const setWhich_is = (id) => {
 which_is = id;
};
